import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-card',
  templateUrl: './card.component.html',
  styleUrls: ['./card.component.scss']
})
export class CardComponent {
  @Input() message: string = '';
  @Input() type: 'info' | 'warning' | 'error' = 'info';
  @Input() width: string = '100%';
}
